"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const common_1 = require("@Const/common");
const clsx_1 = __importDefault(require("clsx"));
const MatchDetailsTable_1 = __importDefault(require("@Components/MatchComponents/MatchDetailsTable"));
const RecordingGroupGridRow = ({ recordingGroup, showRejectedReason, showValue }) => {
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const toggleExpanded = () => setExpanded(!expanded);
    const formatDelimitedString = (str) => {
        if (!str) {
            return str;
        }
        return str.replace(/[,|]/, ', ');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'cell-padding-left', role: 'gridcell' }, recordingGroup.isrc),
        react_1.default.createElement("div", { role: 'gridcell' },
            react_1.default.createElement("div", { className: 'multiline' }, recordingGroup.title)),
        react_1.default.createElement("div", { role: 'gridcell' },
            react_1.default.createElement("div", { className: 'multiline' }, formatDelimitedString(recordingGroup === null || recordingGroup === void 0 ? void 0 : recordingGroup.artist))),
        react_1.default.createElement("div", { role: 'gridcell' },
            react_1.default.createElement("div", { className: 'multiline' }, formatDelimitedString(recordingGroup === null || recordingGroup === void 0 ? void 0 : recordingGroup.writers))),
        showValue && (react_1.default.createElement("div", { role: 'gridcell', className: 'cell-padding-left' }, '$'.repeat(recordingGroup.unmatchedAmount))),
        showRejectedReason && (react_1.default.createElement("div", { role: 'gridcell', className: (0, clsx_1.default)(expanded && 'expanded') },
            react_1.default.createElement("div", { className: 'multiline' }, recordingGroup.rejectionStatusReason))),
        react_1.default.createElement("div", { className: 'cell-padding-right icons', role: 'gridcell' },
            react_1.default.createElement("img", { className: (0, clsx_1.default)('chevron-icon', expanded && 'expanded'), src: common_1.ICONS.chevron_drop_down, onClick: toggleExpanded, alt: 'Expand Icon' })),
        expanded && (react_1.default.createElement("div", { role: 'gridcell', className: 'recording-group-grid-row' },
            react_1.default.createElement(MatchDetailsTable_1.default, { recordings: recordingGroup.recordings })))));
};
exports.default = RecordingGroupGridRow;
